export default __webpack_public_path__ + "static/media/scheba-logo.85e2199c.png";